import React from 'react';
import { Redirect } from 'react-router-dom';

export const RouteHome = ({ session }) => (
  <Redirect to={session.isAuthenticated === true ? '/pages': '/login'} />
);



// WEBPACK FOOTER //
// ./scripts/routers/RouteHome.jsx